//import FuseLoadable
import { FuseLoadable } from "@fuse";
//export bankrecledgerconfig
export const ReportsComponentsConfig = {
  //settings
  settings: {
    //set layout
    layout: {
      //set config as empty object
      config: {}
    }
  },
  //set routes
  routes: [
    {
      path: "/app/bankRec/ReportsComponent",
      component: FuseLoadable({
        loader: () => import("./ReportsComponent.js")
      })
    }
  ]
  //end routes
};
